module.exports = __webpack_public_path__ + "img/ic_burger_shop.813f9ce0.svg";